import { useSelector } from 'react-redux';
import { RootState } from '@/reducers/reducers';
import { selectAuthCredentials } from '@/selectors/selectors';
import { refreshAuthCredentials } from '@/api';
import { AuthCredentials } from '@/types';
import { isTokenRefreshDue } from '@/utils/tokenExpiry';

/**
 * Returns a getter for auth credentials that are guaranteed not to be expired. Only needed where a
 * request is built by hand (file uploads) — everything going through the api layer refreshes on 401.
 */
export function useNonExpiredAuthCredentials(): () => Promise<AuthCredentials> {
    const auth = useSelector((state: RootState) => selectAuthCredentials(state));

    return async () => {
        if (auth && !isTokenRefreshDue(auth.expiry)) {
            return auth;
        }

        return refreshAuthCredentials();
    };
}
